module.exports = __webpack_public_path__ + "0a0d71ce366ed545c10121a5be50279e.jpg";